import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { SidebarRow } from '@/design-system-v2/sidebar-row';

export const SidebarMoreRow = observer(function SidebarMoreRow({
  className,
  onClick,
}: {
  className?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}) {
  return (
    <SidebarRow.Button
      muted
      leading={<SidebarRow.Icon icon={Icons.moreHorizontal} />}
      className={className}
      onClick={onClick}
    >
      More
    </SidebarRow.Button>
  );
});
